import { useEffect } from "react";
export default function useCartChannel(callback) {
    const cartChannel = new BroadcastChannel("cart-channel");
    useEffect(() => {
        cartChannel.onmessage = async (ev) => {
            if (ev.data === "update") {
                callback({
                    type: "updateCart",
                    data: {},
                });
                return;
            }
            const cartMessage = ev.data;
            callback(cartMessage);
        };
        return () => {
            cartChannel.close();
        };
    }, []);
    function sendMessage(message) {
        cartChannel.postMessage(message);
    }
    return { sendMessage };
}
//# sourceMappingURL=useCartChannel.js.map